import finance from '@/api/comptabilite/_admin_finance'

export default {
    name: 'AdminFinanceOverview',
    props: { cashiers: { type: Array, default: () => [] } },
    data() {
        return {
            presets: [{ value: 'day', label: 'Aujourd’hui' }, { value: 'week', label: 'Cette semaine' },
                { value: 'month', label: 'Ce mois' }],
            preset: 'day', startDate: '', endDate: '', cashierId: '',
            dateMode: 'single', dateSimple: '', plageDebut: '', plageFin: '', dateErreur: '',
            loading: false, error: '', summary: null, sequence: 0
        }
    },
    computed: {
        currencyCode() {
            const info = this.$store.getters['info_currency'] || {}
            const label = String(info.principal_currency || '').trim().toUpperCase()
            if (['F.CFA', 'FCFA', 'XOF'].includes(label)) return 'XOF'
            if (['CDF', 'USD'].includes(label)) return label
            return null
        },
        currencyLabel() {
            // À défaut de devise configurée, celle déduite des écritures par le serveur
            const code = this.currencyCode || (this.summary && this.summary.currency) || null
            // Même notation que l'écran Caisse : « FCFA »
            return code === 'XOF' ? 'FCFA' : (code || 'Devise à configurer')
        },
        periodeLabel() { return this.startDate === this.endDate ? this.dateCourte(this.startDate) : `${this.dateCourte(this.startDate)} – ${this.dateCourte(this.endDate)}` },
        titreFiltreDate() { return this.dateMode === 'single' ? 'Date choisie' : 'Entre deux dates' },
        agingBuckets() {
            return [{ key: 'under_30', label: 'Moins de 30 jours' }, { key: 'days_30_60', label: '30 à 60 jours' },
                { key: 'days_61_90', label: '61 à 90 jours' }, { key: 'over_90', label: 'Plus de 90 jours' }]
        },
        activityRows() {
            return Object.entries((this.summary || {}).activity || {})
                .map(([name, values]) => ({ name, amount: values.amount, count: values.count }))
                .sort((a, b) => b.amount - a.amount)
        }
    },
    mounted() { this.choisir('day') },
    methods: {
        nombre(value) { return value === null || value === undefined ? '—' : new Intl.NumberFormat('fr-FR').format(value) },
        dateCourte(value) {
            if (!value) return '—'
            const [year, month, day] = value.split('-')
            return `${day}/${month}/${year}`
        },
        variation(current, previous) {
            if (current === null || previous === null) return '—'
            if (previous === 0) return current === 0 ? 'Stable' : 'Nouvelle activité'
            const percent = Math.round(((current - previous) / previous) * 100)
            return `${percent > 0 ? '+' : ''}${percent} %`
        },
        variationClass(current, previous, inverse = false) {
            if (current === null || previous === null || current === previous) return 'neutral'
            return (current > previous) !== inverse ? 'up' : 'down'
        },
        activityShare(amount) {
            const total = (this.activityRows || []).reduce((sum, row) => sum + row.amount, 0)
            return total > 0 ? Math.max(2, Math.round((amount / total) * 100)) : 0
        },
        isoDate(date) {
            const parts = new Intl.DateTimeFormat('en-CA', {
                timeZone: (this.info_clinique || {}).fuseau_horaire || Intl.DateTimeFormat().resolvedOptions().timeZone,
                year: 'numeric', month: '2-digit', day: '2-digit'
            }).formatToParts(date).reduce((acc, item) => { acc[item.type] = item.value; return acc }, {})
            return `${parts.year}-${parts.month}-${parts.day}`
        },
        choisir(value) {
            this.preset = value
            const today = this.isoDate(new Date())
            this.endDate = today
            if (value === 'day') this.startDate = today
            else {
                const day = new Date(`${today}T12:00:00`)
                if (value === 'week') day.setDate(day.getDate() - ((day.getDay() + 6) % 7))
                else day.setDate(1)
                this.startDate = this.isoDate(day)
            }
            if (!this.dateSimple) this.dateSimple = today
            if (!this.plageDebut) this.plageDebut = this.startDate
            if (!this.plageFin) this.plageFin = today
            this.dateErreur = ''
            this.charger()
        },
        appliquerFiltreDate() {
            const debut = this.dateMode === 'single' ? this.dateSimple : this.plageDebut
            const fin = this.dateMode === 'single' ? this.dateSimple : this.plageFin
            if (!debut || !fin || debut > fin) {
                this.dateErreur = 'Choisissez une date ou un intervalle valide.'
                return
            }
            this.dateErreur = ''
            this.startDate = debut
            this.endDate = fin
            this.preset = 'custom'
            if (this.$refs.filtreDate) this.$refs.filtreDate.open = false
            this.charger()
        },
        async charger() {
            if (!this.startDate || !this.endDate) {
                this.error = 'Période non configurée.'
                return
            }
            const sequence = ++this.sequence
            this.loading = true
            this.error = ''
            try {
                // Sans devise : le serveur compte aussi les écritures historiques (ancienne devise « F.CFA » par défaut)
                const summary = await finance.summary({ start_date: this.startDate, end_date: this.endDate,
                    cashier_id: this.cashierId || undefined })
                if (sequence === this.sequence) this.summary = summary
            } catch (error) {
                if (sequence === this.sequence) { this.summary = null; this.error = 'Les indicateurs financiers ne sont pas disponibles.' }
            } finally {
                if (sequence === this.sequence) this.loading = false
            }
        }
    }
}
